import { render, staticRenderFns } from "./PromoItem.vue?vue&type=template&id=21651f3e&scoped=true&"
import script from "./PromoItem.vue?vue&type=script&lang=js&"
export * from "./PromoItem.vue?vue&type=script&lang=js&"
import style0 from "./PromoItem.vue?vue&type=style&index=0&id=21651f3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21651f3e",
  null
  
)

export default component.exports